import { Flex, Paper, Text } from "@pillar-ui/core";
import { Heart } from "@pillar-ui/icons";
import colors from "../styles/colors";
import { useEffect, useState } from "react";
import nationalDayIconSrc from "../assets/icons/vn-national-day.png";
import halloweenIconSrc from "../assets/icons/halloween.png";
import lunarIconSrc from "../assets/icons/tet-icon.jpg";
import { checkHoliday } from "../common/utils";

let iconSrc = "";
(() => {
  const holiday = checkHoliday();

  switch (holiday) {
    case "independence":
      iconSrc = nationalDayIconSrc;
      break;
    case "halloween":
      iconSrc = halloweenIconSrc;
      break;
    case "lunar":
      iconSrc = lunarIconSrc;
      break;
    default:
  }
})();

const Header = () => {
  const [timeDisplay, setTimeDisplay] = useState("");

  const generateTimeDisplay = () => {
    const now = new Date();
    const startLunchTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      10,
      30,
      0,
      0,
    );
    const endLunchTime = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      12,
      0,
      0,
      0,
    );
    if (endLunchTime.getTime() < now.getTime()) {
      return (
        <>
          <Paper mb="2">
            <Text size="5" style={{ color: colors.white }}>
              {"Đã hết giờ ăn trưa!"}
            </Text>
          </Paper>
          <Flex direction="row" gap="2" style={{ alignItems: "center" }}>
            <Text size="5" style={{ color: colors.white }}>
              {"Hẹn gặp lại ngày tới"}
            </Text>
            <Heart
              color={colors.white}
              height={16}
              strokeWidth={3}
              width={16}
            />
          </Flex>
        </>
      );
    } else if (
      endLunchTime.getTime() > now.getTime() &&
      now.getTime() > startLunchTime.getTime()
    ) {
      return (
        <Text size="5" style={{ color: colors.white }}>
          {"Chúc ngon miệng!"}
        </Text>
      );
    }
    const timeGap = startLunchTime.getTime() - now.getTime();
    const hours = Math.floor(timeGap / (60 * 60 * 1000));
    const minutes = Math.ceil((timeGap % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.ceil(
      ((timeGap % (60 * 60 * 1000)) % (60 * 1000)) / 1000,
    );

    return (
      <Text size="5" style={{ color: colors.white }}>
        {`Còn ${String(hours).padStart(2, "0")}:${String(minutes).padStart(
          2,
          "0",
        )}:${String(seconds).padStart(2, "0")} nữa thôi`}
      </Text>
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeDisplay(generateTimeDisplay());
    }, 1000);
    setTimeDisplay(generateTimeDisplay());

    return () => clearInterval(interval);
  }, []);

  return (
    <Paper
      p="5"
      background="P11"
      width="100%"
      height="100px"
      style={{ position: "sticky", left: 0, top: 0, zIndex: 99 }}
    >
      <Flex
        direction="row"
        justify="between"
        items="center"
        style={{ maxWidth: "100%", height: "100%" }}
      >
        <Paper>
          <Flex direction="row" gap="2" items="center">
            {/* <Meat color={colors.white} height={48} strokeWidth={2} width={48} /> */}
            {iconSrc && <img alt={iconSrc} src={iconSrc} width={48} />}
            <Text size="9" style={{ color: colors.white, fontWeight: 700 }}>
              {"Hẹn Ăn Trưa"}
            </Text>
          </Flex>
        </Paper>
        <Paper style={{ textAlign: "right" }}>{timeDisplay}</Paper>
      </Flex>
    </Paper>
  );
};

export default Header;
